<script lang="ts">
    import { Col } from "sveltestrap";
    import { FancyFontMessage, Headings } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    let subhead : string = "Use the included utility classes to recreate the small secondary heading text."
</script>

<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={Headings} headerContent={subhead} CardBodyprops="typography">
        <div slot="contentbody">
            <h3>{@html FancyFontMessage}</h3>
        </div>
    </Card>
</Col>
